/* eslint-disable @ok/oklint/no-hardcode-variable */
/* eslint-disable @ok/oklint/no-space */
export default {
  index_assets_total: '总资产',
  index_assets_top_crypto: '主流币',
  index_assets_top_fluctuation: '涨幅榜',
  index_medias_title: '媒体',
  tutor_page_title: '安卓手机',
  tutor_page_step1:
    '打开OKJ APP ,选择交易-点击页面右上方K线按钮，进入K线页面，或选择贩卖所- K线页面；在K线页面点击下方「盯盘」图标。',
  tutor_page_step2:
    '开启实时盯盘，并授予「允许在应用上层展示」权限；点击「添加币种」--在新页面选择币种--点击「保存」完成操作。',
  see_more: '查看更多',
  rss_page_title: '市场动向',
  btc_index_top_subtitle:
    'OKJ BTC Index，是在每天公开的，代表在OKJ买入/卖出1个BTC 的价格指数。',
  btc_index_tip1:
    '该页面展示的价格，并不保证OKCoin Japan K.K. 亦或是其他交易的参与方能够以此价格与客户交易。 在交易前请务必查看我们的交易信息。',
  btc_index_tip2:
    '由于我们运营上的限制等原因，所公布的信息可能会有一些时间延迟。可能受系统维护等影响造成展示的价格与实际价格不同，请您谅解。',
  btc_index_tip3: '所列价格信息是在其创建日期和时间时的信息，仅供参考。',
  btc_index_download_csv_file: '下载CSV文件',
  btc_index_download_csv_title: '历史数据',
  btc_index_crypto_currency_name: '加密货币',
  btc_index_crypto_currency_purchase: '买入价',
  btc_index_crypto_currency_sell: '卖出价',
  btc_index_crypto_currency_market_price: '中间价',
  btc_index_crypto_currency_btc: '比特币',
  btc_index_crypto_currency_date: '日期',
  btc_index_crypto_currency_unit: '日元',
  btc_index_crypto_currency_today: '今日',
  btc_index_crypto_currency_yesterday: '昨日',
  btc_index_year_split_symbol: '年',
  btc_index_month_split_symbol: '月',
  btc_index_day_split_symbol: '日',
  view_all: '查看全部',
  currency_info_data_title: '{currencyName}价格实时数据',
  currency_folder_close: '收起',
  today_change_date: '今日',
  seven_days_date: '7天',
  thirty_days_date: '30天',
  this_year_date: '1年',
  currency_office_site: '官网',
  currency_white_paper: '白皮书',
  currency_office_github: 'Github',
  currency_block_explorer: '区块浏览器',
  currency_block_twitter: 'Twitter',
  currency_block_facebook: 'facebook',
  currency_price_performance: '价格表现',
  currency_time_range: '时间范围',
  currency_price_amount: '涨跌额',
  currency_price_rate: '涨跌幅',
  currency_market_info: '（{currencyName}）市场信息',
  currency_market_value: '市值',
  currency_history_highest_price: '历史最高价',
  currency_history_lowest_price: '历史最低价',
  currency_first_release: '首次发行时间',
  currency_history_max_offer: '最大供应量',
  currency_circulation_amount: '流通量',
  currency_circulation_rate: '流通率(％)',
  currency_belong_link: '所属公链',
  currency_admit_ways: '承认方式',
  currency_base_info_title: '关于{symbolFullName}（{symbol}）',
  currency_buy_calculator_button: '购买',
  currency_buy_calculator_pay: '支付',
  currency_buy_calculator_get: '得到',
  currency_buy_calculator_title: '{symbol}计算器',
  currency_trade_title: '交易',
  currency_staking_title: '锁仓挖矿',
  currency_sns_title: '关注官方SNS账号',
  currency_media_title: '相关新闻',
  currency_go_trade: '去交易',
  currency_go_apply: '去申请',
  currency_staking_content1: '轻松申请存储！',
  currency_staking_content2: '获得每日收益',
  currency_to_concern: '去关注',
  faq_content_title: '关于{symbol}的常见问题',
  resource_title_about: '关于{symbol}的详细信息',
  currency_base_info_increase_tips1:
    '{symbol}今天的价格是¥{price}。{symbol}的价格在过去24小时内上涨了{percentage}%。我们会实时更新{symbol}/JPY的价格。',
  currency_base_info_decrease_tips1:
    '{symbol}今天的价格是¥{price}。{symbol}的价格在过去24小时内下跌了{percentage}%。我们会实时更新{symbol}/JPY的价格。',
  currency_base_info_tips2:
    '目前，该币种市值排名为第{rankNumber}名，实时市值为¥{volumeCap}亿。',
  currency_base_info_tips3:
    '其流通供应量为{circulationAmount}{symbol}，总供应量为{distributionAmount}{symbol}。',
  currency_circulation_rate_tip: '流通量/最大供应量',
  currency_circulation_amount_tip:
    '目前该币种在市场流通的数量（数据口径：综合全网专业平台数据）',
  currency_history_max_offer_tip: '该币种可在市场流通的最大数量',
  currency_breadcrumbs_spot_title: '行情',
  currency_breadcrumbs_sale_title: '贩卖所',
  currency_breadcrumbs_trade_title: '现货交易',
  currency_breadcrumbs_title: '价格',
  currency_year_split_symbol: '年',
  currency_month_split_symbol: '月',
  currency_day_split_symbol: '日',
  currency_price: '价格',
  web_homepage_recurringbuy_title: '定投',
  web_homepage_staking_title: '锁仓挖矿',
  web_homepage_staking_desc:
    '您只需持有目标加密资产，即可每天赚取利润（质押奖励）。',
  web_homepage_staking_rate: '最高年化',
  web_homepage_staking_soon: '待上线',
  view_home_register_right_tip1: '24/7均可充提',
  view_home_register_right_tip2: '全球标准交易所点差',
  view_home_register_right_tip3: '支持高流动性和快速交易',
  view_home_reason_title: '选择OKJ的5个理由',
  view_home_reason_security_tip1: '稳固的安全系统',
  view_home_reason_security_tip2: '及全方位的客服支持',
  view_home_reason_security_tip3: '100% 冷钱包中进行管理',
  view_home_reason_security_tip4: '二次验证增强资产安全性',
  view_home_reason_security_tip5: '快速响应的客户服务',
  view_home_reason_security_title1: '安全设置',
  view_home_reason_security_title2: '',
  view_home_reason_balance_tip1: '快速安全的',
  view_home_reason_balance_tip2: '充提币/出入金',
  view_home_reason_balance_tip3: '丰富的多链支持',
  view_home_reason_balance_tip4: '全年每天24小时即时响应',
  view_home_reason_balance_tip5: '支持日元和加密资产的充提',
  view_home_reason_balance_title1: '资产管理',
  view_home_reason_balance_title2: '',
  view_home_reason_trade_tip1: '高流动性',
  view_home_reason_trade_tip2: '低点差',
  view_home_reason_trade_tip3: '全球标准的交易环境',
  view_home_reason_trade_tip4: '支持丰富的币对交易',
  view_home_reason_trade_tip5: '高效便利的交易工具',
  view_home_reason_trade_title1: '交易所',
  view_home_reason_trade_title2: '',
  view_home_reason_api_tip1: '强大稳定的',
  view_home_reason_api_tip2: '交易API',
  view_home_reason_api_tip3: '支持Websocket和REST API',
  view_home_reason_api_tip4: '较高的request API上限',
  view_home_reason_api_tip5: '提供SDK支持',
  view_home_reason_api_title1: 'API规范',
  view_home_reason_api_title2: '',
  view_home_reason_inquiryForm_tip1: '全方位的',
  view_home_reason_inquiryForm_tip2: '企业服务',
  view_home_reason_inquiryForm_tip3: '对应【月末時価評価税適用外】税法制度',
  view_home_reason_inquiryForm_tip4: '支持大额交易',
  view_home_reason_inquiryForm_tip5: '向海外法人开放服务',
  view_home_reason_inquiryForm_title1: '问题咨询',
  view_home_reason_inquiryForm_title2: '',
  view_home_flow_title_tips2: '只需 15 分钟即可开始交易！',
  view_home_flow_step1_title: '请使用邮箱注册',
  view_home_flow_step2_title1: '输入您的个人信息后',
  view_home_flow_step2_title2: '使用 eKYC进行身份验证',
  view_home_flow_step3_title: '开始交易！',
  view_home_sale_card_title: '简单、轻松开始交易',
  view_home_sale_card_btn: '开始交易',
  view_index_news_title: '公告',
  view_index_market_news_title: '市场动向',
  view_index_news_btn: '查看更多',
  view_home_faq_title: '常见问题',
  view_home_faq_guidelines_page: '指南页面',
  view_home_faq_more_link: 'https://support.okj.com/hc/zh-cn',
  view_home_faq_click_here: '单击此处',
  view_home_faq_first_title: '开户需要多长时间？',
  view_home_faq_first_info1: '包括身份验证在内的开户流程最快可在5分钟内完成。',
  view_home_faq_first_info2: '请',
  view_home_faq_first_info3: '了解开户所需的流程。',
  view_home_faq_first_info4:
    '※开户需要审核。根据情况，完成审核可能需要一些时间。',
  view_home_faq_second_title: '法人（企业客户）可以开户吗？',
  view_home_faq_second_info1: '企业客户也可以开立账户并使用该服务。',
  view_home_faq_second_info2: '',
  view_home_faq_second_info3: '了解开户所需的流程。',
  view_home_faq_third_title: '入金/出金需要多长时间？',
  view_home_faq_third_info1:
    'OKJ一年365天24小时支持日元的存取款和加密资产的存取款。',
  view_home_faq_third_info2: '您可以使用该服务，不错过任何交易机会。',
  view_home_faq_fourth_title: '请介绍一下你们支持的虚拟货币',
  view_home_faq_fourth_info1:
    '除了 BTC、ETH 和 XRP之外，我们还提供范围广泛的主流加密货币，可以在交易所或贩卖所进行交易。',
  view_home_faq_fourth_info2: '',
  view_home_faq_fourth_info3: '查看交易所支持的币对，',
  view_home_faq_fourth_info4: '查看贩卖所支持的币种。',
  view_home_faq_fifth_title: '交易所和贩卖所的区别是什么',
  view_home_faq_fifth_info1:
    '交易所匹配买卖双方的订单。 它也被称为撮合交易，因为参与者的订单形成了一个订单簿。 您可以选择如何以较低的交易成本进行交易。',
  view_home_faq_fifth_info2:
    '贩卖所是一种场外交易，客户在下订单后立即与加密货币交易所服务提供商进行交易。 您可以通过简单的操作进行买卖，对于初学者来说也很容易使用。',
  view_home_faq_sixth_title: '介绍staking服务',
  view_home_faq_sixth_info1:
    'Staking 是一种允许您持有加密资产并为区块链的维护和批准做出贡献的机制。您可以通过您的贡献获得staking奖励。',
  view_home_faq_sixth_info2:
    '使用OKJ的质押服务，您每天都可以获得奖励，您可以随时申请或取消。',
  view_home_faq_sixth_info3: '请查看',
  view_home_faq_sixth_info4: '以了解详细的规则和条件。',
  view_home_faq_seventh_title: '介绍 Flash Deals 的信息',
  view_home_faq_seventh_info1:
    '通过参加Flash Deals，您可以在有限的时间内获得高额奖励。 对每笔交易，确定目标加密资产、奖励（年率）、执行周期、接受数量，不定期执行。',
  view_home_faq_seventh_info2: '请查看',
  view_home_faq_seventh_info3: '以了解详细的规则和条件。',
  web_banner_register_button: '立即注册',
  web_homepage_download: '下载App',
  web_homepage_product_buysell_dec:
    '您可以轻松买卖加密资产，易理解，适合初学者。',
  web_homepage_product_trade_dec:
    '您可以自行设定价格交易加密资产。所有执行方法和高级 API 连接均可用。',
  web_homepage_bottom_download_title: '立即下载应用程序',
  web_homepage_recurringbuy_desc:
    '这是一项允许您定期自动购买固定数量的加密资产的服务。',
  web_homepage_download_subtitle: '随时随地，轻松交易',
  web_homepage_download_register: '注册',
  web_homepage_sale_title: '贩卖所',
  web_homepage_trade_title: '现货交易',
  web_homepage_trade_volume: '24H成交量',
  web_homepage_trade_date: '日期',
  // Recruit pages
  recruit_top_hero_desc:
    '金融厅注册加密资产交易所，正在日本构建全球化交易体验。',
  recruit_top_openings_title: '热招岗位',
  recruit_filter_all: '全部',
  recruit_top_more: '查看更多',
  recruit_top_reasons_title: '为什么加入我们',
  recruit_reason_flat_title: '扁平化团队',
  recruit_reason_flat_desc: '不拘职级，自由表达想法，决策高效推进',
  recruit_reason_global_title: '全球 × 本地',
  recruit_reason_global_desc: '融合全球标准，服务日本市场',
  recruit_reason_learn_title: '学习与成长',
  recruit_reason_learn_desc: '在 Web3 前沿持续学习与实践',
  recruit_reason_speed_title: '速度与执行力',
  recruit_reason_speed_desc: '高效协作，持续交付',
  recruit_apply: '应聘',
  recruit_job_openings: '热招岗位',
  recruit_job_description: '岗位详情',
  recruit_job_relevant_title: '相关岗位',
  recruit_job_more: '更多',
  recruit_submit_apply: '申请该岗位',
  recruit_submit_to_job_desc: '浏览岗位说明',
  recruit_form_family_name: '姓',
  recruit_form_first_name: '名',
  recruit_form_birthday: '生日',
  recruit_form_email: '邮箱',
  recruit_form_location: '所在地（国名・城市名、例: 日本・东京）',
  recruit_form_resume: '简历',
  recruit_form_cv: '职务履历书、作品集等',
  recruit_form_salary: '期望年收入',
  recruit_form_jpy: '日元',
  recruit_form_desired: '期望事项',
  recruit_form_privacy: '招聘活动中的个人信息处理说明',
  recruit_form_submit: '提交',
  recruit_form_email_invalid: '请输入正确的邮箱。',
  recruit_form_digits_only: '请输入数字。',
  recruit_top_jp_only_notice: '*职位描述目前仅提供日文版本',
  recruit_top_filter_aria: '职位类型筛选',
  recruit_back: '返回',
  recruit_form_gender: '性别',
  recruit_form_gender_male: '男',
  recruit_form_gender_female: '女',
  recruit_form_family_name_required: '请输入姓',
  recruit_form_first_name_required: '请输入名',
  recruit_form_birthday_required: '请输入生日',
  recruit_form_email_required: '请输入邮箱',
  recruit_form_location_required: '请输入所在地',
  recruit_upload_attach: '请上传文件',
  recruit_upload_attach_hint:
    '（支持 .pdf / .doc / .docx / .xls / .xlsx / .png / .jpg / .jpeg，5MB 以内）',
  recruit_upload_resume_required: '请上传简历。',
  recruit_upload_format_invalid: '不支持的文件格式。',
  recruit_upload_size_invalid: '可上传的文件大小在 5MB 以内。',
  recruit_upload_total_size_invalid: '可上传的文件总大小不超过 15MB。',
  recruit_upload_contact_prefix: '如果无法上传，请联系',
  recruit_upload_contact_suffix: '。',
  recruit_copied: '已复制',
  recruit_submit_success: '提交成功',
  recruit_dialog_ok: '确定',
  recruit_recaptcha_load_failed: '安全验证加载失败，请刷新页面。',
  recruit_recaptcha_failed: '安全验证失败。',
  // ekyc refactor
  'kyc.mini.title': '简易身份认证',
  'kyc.mini.app.no.title': '未在手机上安装OKJ应用的用户',
  'kyc.mini.app.no.desc': '请前往应用商店下载应用',
  'kyc.mini.app.have.title': '已在手机上安装OKJ应用的用户',
  'kyc.mini.app.have.desc': '已下载用户（需为1.4.1及以上版本）',
  'kyc.mini.toekyc.button': '前往eKYC',
  'kyc.mini.tips.title': '注意事项',
  'kyc.mini.tips.desc.1': '＊请提交与当前居住地址一致且在有效期内的证件。',
  'kyc.mini.tips.desc.2':
    '＊“通知卡”不可作为个人编号卡（My Number Card）使用。',
  'kyc.mini.tips.desc.3': '＊外籍用户请提交在留卡或特别永住者证明书。',

  // 用户迁移升级 -- start
  web_update_popup_title: 'OKJ交易系统升级',
  web_update_popup_tips_one: 'OKJ的交易系统已全面更新。',
  web_update_popup_tips_two: '要升级到新的交易系统，请点击“立即更新”按钮。',

  web_update_popup_tips_adv_title: '■ 主要特点',
  web_update_popup_tips_adv_one: '1. 提升核心交易功能',
  web_update_popup_tips_adv_two: '2. 焕新用户界面，提供更加流畅的交易体验',
  web_update_popup_tips_adv_three:
    '3. 强化大流量承载能力，确保系统高稳定性',

  web_update_popup_tips_notice_title: '■ 注意事项',
  web_update_popup_tips_notice_one:
    '※ 升级时的未成交订单将在升级完成后自动撤销。',
  web_update_popup_tips_notice_two: '※ 升级后，交易账户内的余额将全部划转至资金（充提）账户。如需在交易所进行交易，需要从资金账户划转至交易账户。',
  web_update_popup_tips_notice_three:
    '※ 当前系统与升级后的系统在交易所订单簿环境上存在差异。请预先知悉，在过渡期间，由于流动性下降，可能会导致买卖价差扩大或暂停接单等情况，从而无法按预期进行交易。',
  web_update_popup_tips_detail_url_one:
    '详情请参阅此处：',
  web_update_popup_tips_detail_url_two:
    'https://support.okj.com/hc/ja/articles/61545708098969',

  web_update_popup_button_later: '稍后更新',
  web_update_popup_button_now: '立即更新',
  web_update_popup_precontract_title: '【重要事项】',
  web_update_popup_precontract_link1: '请在升级前阅读',
  web_update_popup_precontract_link2: '《加密资产现货交易说明书》',
  web_update_popup_precontract_link3: '。',
  web_update_popup_precontract_agree: '我已确认上述内容',

  // 二次确认弹窗
  web_update_popup_confirm_title: '【重要】API v3 用户请注意',
  web_update_popup_confirm_content:
    '随着交易系统的升级，我们将从目前使用的 API v3 迁移至新版本的 API v5。',
  web_update_popup_confirm_doc_title: '各版本对应的 API 文档请参阅下方链接：',
  web_update_popup_confirm_doc_v3: '当前版本（v3）',
  web_update_popup_confirm_doc_v3_link: 'https://dev.okj.com/apidoc/v3',
  web_update_popup_confirm_doc_v3v5: '过渡升级版（v3v5）',
  web_update_popup_confirm_doc_v3v5_link: 'https://dev.okj.com/apidoc/v3v5',
  web_update_popup_confirm_doc_v5: '完整升级版（v5）',
  web_update_popup_confirm_doc_v5_link: 'https://dev.okj.com/apidoc/v5',
  web_update_popup_confirm_note:
    '※ 注意 在升级完成之前，API v3v5 及 API v5 暂无法使用。',
  web_update_popup_confirm_content_continue:
    '此外，参照下方 API v3 升级指南 并配置新的 Endpoint（端点）与参数后，您可在一定期限内继续使用目前的 API v3。',
  web_update_popup_confirm_guideline: 'API 迁移指南',
  web_update_popup_confirm_guideline_link: 'https://dev.okj.com/apidoc/v3v5/zh/#change-api-migration-guideline',
  web_update_popup_confirm_checkbox: '我已确认上述内容',
  web_update_popup_confirm_button_ok: '确认',
  web_update_popup_confirm_button_cancel: '取消',

  web_update_popup_upgrading_title: '升级中',
  web_update_popup_upgrading_tips: '交易系统升级中，预计 {minute} 分钟内完成',
  web_update_popup_upgrading_abnormal_tips:
    '若长时间未完成升级，请点击问题咨询',
  web_update_popup_upgrading_button: '问题咨询',

  web_update_popup_upgrade_complete_title: '交易系统升级完成',
  web_update_popup_upgrade_complete_tips: '点击开始交易',
  web_update_popup_upgrade_complete_button_trade: '开始交易',
  // 用户迁移升级 -- end
};
